module.exports = __webpack_public_path__ + "static/media/heroku.1941c5de.jpg";